import styled from "styled-components";
import LayerItem from "./LayerItem";
import ColorLegend from "../Legends/ColorLegend";
import { LEGEND_FIRE_DANGER_SHP, LEGEND_SATELLITE } from "../../constants/legends";
import GradientLegend from "../Legends/GradientLegend";

export default function SelectLayer({
  isSatellite,
  toggleSatellite,
  isFireDangerSHP,
  toggleFireDangerSHP,
  isEffisFireDanger,
  toggleEffisFireDanger,
}) {
  return (
    <SelectLayerContainer>
      <LayerItem title="Vegetation" id="vatellite" checked={true} disabled={true} />
      <ColorLegend object={LEGEND_SATELLITE} />
      <LayerItem title="Satellite" id="satellite" checked={isSatellite} onChange={toggleSatellite} />
      <LayerItem title="Fire Danger (SHP)" id="fire_danger_shp" checked={isFireDangerSHP} onChange={toggleFireDangerSHP} />
      {isFireDangerSHP && <ColorLegend object={LEGEND_FIRE_DANGER_SHP} />}
      <LayerItem title="EFFIS Fire Danger (WMS), %" id="effis_fire_danger" checked={isEffisFireDanger} onChange={toggleEffisFireDanger} />
      {isEffisFireDanger && <GradientLegend />}
    </SelectLayerContainer>
  );
}

const SelectLayerContainer = styled.div`
  display: grid;
  background-color: white;
  padding: 15px;
  gap: 5px;
  border-radius: 5px;
  font-size: 14px;
`;
